module.exports = __webpack_public_path__ + "static/media/view_chart.8d90d524.svg";